import { CollapsingSidebar } from 'components/pages/sidebar/CollapsingSidebar'
import { getAdminNavItems } from 'components/pages/sidebar/NavMetadata'
import { AdminModeContext, DashboardContext } from 'lib/context/app'
import { FC, useContext } from 'react'
import { useIntl } from 'react-intl'

export type SidenavState = string[]

export const Sidebar: FC = () => {
    const intl = useIntl()
    const dashboardContext = useContext(DashboardContext)
    const adminModeContext = useContext(AdminModeContext)
    const adminNavs = getAdminNavItems(intl, dashboardContext)

    return (adminModeContext.isOnAdminPath && adminModeContext.hasAdminRole)
        ? <CollapsingSidebar items={adminNavs} />
        : null
}
